export default "__VITE_ASSET__RuTgEzwp__"